export enum Status {
	INACTIVE 		= { code: 'INACTIVE', description: 'GENERAL.INACTIVE', color: 'dark' } as any,
	ACTIVE 			= { code: 'ACTIVE', description: 'GENERAL.ACTIVE', color: 'green' } as any,
	DRAFT			= { code: 'DRAFT', description: 'GENERAL.DRAFT', color: 'dark' } as any,
	REMOVED 		= { code: 'REMOVED', description: 'GENERAL.REMOVED', color: 'dark' } as any,
	PAUSED 			= { code: 'PAUSED', description: 'GENERAL.PAUSED', color: 'primary' } as any,
	CLOSED 			= { code: 'CLOSED', description: 'GENERAL.CLOSED', color: 'red' } as any,
	TRIAL_EXPIRED 	= { code: 'TRIAL_EXPIRED', description: 'GENERAL.TRIAL_EXPIRED', color: 'red' } as any,
	CANCELED 		= { code: 'CANCELED', description: 'GENERAL.CANCELED', color: 'red' } as any,
	SUSPEND			= { code: 'SUSPEND', description: 'GENERAL.SUSPEND', color: 'red' } as any,
	REACTIVATING	= { code: 'REACTIVATING', description: 'GENERAL.REACTIVATING', color: 'red' } as any,
	BLOCKED			= { code: 'BLOCKED', description: 'GENERAL.BLOCKED', color: 'red' } as any,

	// Usado para caso algum status desconhecido seja setado, e evitar crash na tela	
	UNKNOWN			= { code: 'UNKNOWN', description: 'GENERAL.UNKNOWN', color: 'red' } as any,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/status.enum.ts